// export default {
//   BUVoucherListRealExpense
// };

var helps = [
  //#region Help

  /** Trợ giúp */
  'Help',
  /** Đăng nhập vào phần mềm */
  'Login',
  /** Tạo dữ liệu kế toán mới */
  'CreateDatabase',
  /** Chuyển đổi dữ liệu từ MISA Mimosa 2022 lên MISA Mimosa Online */
  'ConvertDatabase',
  /** Khai báo số dư ban đầu */
  'InitDefaultAmount',
  /** Hệ thống tài khoản */
  'SystemAccountList',
  /** Tài khoản kết chuyển */
  'AccountTransfer',
  /** Tài khoản ngầm định */
  'DefaultAccountList',
  /** Định khoản tự động */
  'AutoBusiness',
  /** Tính chất nguồn kinh phí */
  'BudgetSourceProperty',
  /** Nguồn kinh phí */
  'BudgetSource',
  /** Mã dự phòng */
  'BudgetProvide',
  /** Chương */
  'BudgetChapter',
  /** Loại khoản */
  'BudgetKindItem',
  /** Nhóm mục chi */
  'BudgetGroupItem',
  /** Mục/Tiểu mục */
  'BudgetItem',
  /** Phòng/ban */
  'Department',
  /** Loại cán bộ */
  'EmployeeType',
  /** Khoản lương */
  'PayrollItem',
  /** Ngạch lương */
  'SalaryScale',
  /** Quy định lương, thuế, bảo hiểm */
  'PAOption',
  /** Khách hàng/Nhà cung cấp */
  'CustomerVender',
  /** Loại khách hàng/Nhà cung cấp */
  'AccountingObject',
  /** Loại tài khoản tiềm gửi kho bạc */
  'BankInfoCategory',
  /** Tài khoản ngân hàng, kho bạc */
  'BankInfo',
  /** Cán bộ */
  'Employee',
  /** Kho */
  'Stock',
  /** Vật tư hàng hóa */
  'InventoryItem',
  /** Loại vật tư hàng hóa */
  'InventoryCategory',
  /** Công cụ dụng cụ */
  'ToolList',
  /** Loại công cụ dụng cụ */
  'ToolType',
  /** Loại tài sản cố định */
  'FixAssetType',
  /** Tài sản cố định */
  'FixAsset',
  /** Loại quỹ */
  'FundType',
  /** CTMT, Dự án */
  'Project',
  /** Phí, lệ phí */
  'Fee',
  /** Nhóm hàng hóa dịch vụ mua vào */
  'PurchasePurpose',
  /** Mẫu số hóa đơn */
  'InvoiceFormNumber',
  /** Loại chứng từ */
  'VoucherType',
  /** Nhiệm vụ */
  'Task',
  /** Hoạt động */
  'Activity',
  /** Mã thống kê */
  'Statistics',
  /** Cơ cấu vốn */
  'FundStructure',
  /** Đề tài */
  'Topic',
  /** Loại tiền */
  'Currency',
  /** Hợp đồng */
  'Contract',

  //#endregion

  //#region Kho bạc

  /** Kho bạc */
  'Treasury',
  /** Nhập dự toán */
  'BUPlanImport',
  /** Nhận dự toán */
  'BUPlanReceipt',
  /** Điều chỉnh dự toán */
  'BUPlanAdjustment',
  /** Hủy dự toán */
  'BUPlanCancle',
  /** Chuyển khoản kho bạc */
  'BUTransfer',
  /** Chuyển khoản kho bạc bằng TK tiền gửi */
  'BUTransferDeposit',
  /** Nhập cam kết chi ban đầu */
  'BUOpeningCommitment',
  /** Đề nghị cam kết chi */
  'BUCommitmentRequest',
  /** Điều chỉnh cam kết chi */
  'BUCommitmentAdjustment',
  /** Rút dự toán tạm ứng đã cấp bằng tiền mặt */
  'CAPlanWithDraw',
  /** Rút dự toán tạm ứng đã cấp dự toán bằng tiền gửi */
  'BUPlanWithDraw',
  /** Rút dự toán tạm ứng đã cấp bằng chuyển khoản kho bạc */
  'BUPlanWithDrawTransfer',
  /** Rút dự toán tạm ứng chưa cấp bằng tiền mặt */
  'CAPlanWithDrawNotPlaned',
  /** Rút dự toán tạm ứng chưa cấp dự toán bằng tiền gửi */
  'BUPlanWithDrawNotPlaned',
  /** Rút dự toán tạm ứng chưa cấp bằng chuyển khoản kho bạc */
  'BUPlanWithDrawTransferNotPlaned',
  /** Rút dự toán thực chi bằng tiền mặt */
  'CAPlanWithDrawRealExpense',
  /** Rút dự toán thực chi bằng tiền gửi */
  'BUPlanWithDrawRealExpense',
  /** Rút dự toán thực chi bằng chuyển khoản kho bạc */
  'BUPlanWithDrawTransferRealExpense',
  /** Rút dự toán chuyển khoản lương, bảo hiểm */
  'BUPlanWithDrawTransferPAOption',
  /** Điều chỉnh kinh phí */
  'BUPlanWDAdjustment',
  /** Dự toán giữ lại */
  'BUBudgetReserve',
  /** Bảng kê chứng từ thanh toán đã cấp dự toán */
  'BUVoucherList',
  /** Bảng kê chứng từ thanh toán chưa cấp dự toán */
  'BUVoucherListNotPlaned',
  /** Bảng kê chứng từ ghi thu ghi chi */
  'BUVoucherListReceiptExpense',
  /** Lập bảng kê chứng từ thanh toán thực chi */
  'BUVoucherListRealExpense',
  /** Bảng kê khác */
  'BUVoucherListOther',

  //#endregion

  //#region Kế toán tiền mặt

  /** Tiền mặt */
  'Cash',
  /** Phiếu thu */
  'CAReceipt',
  /** Rút tiền gửi NHKB nhập quỹ tiền mặt */
  'CAReceiptWithDraw',
  /** Nhận các khoản kinh phí bằng tiền mặt */
  'CAReceiptPlanWithDraw',
  /** Chi tiền mặt nộp vào tài khoản ngân hàng */
  'CAPaymentDeposit',
  /** Phiếu chi */
  'CAPayment',

  //#endregion

  //#region Kế toán tiền gửi

  /** Tiền gửi */
  'Deposits',
  /** Thu tiền gửi */
  'BADeposit',
  /** Chi tiền gửi */
  'BAWithDraw',
  /** Chuyển tiền nội bộ */
  'BABankTransfer',

  //#endregion

  //#region Kế toán Tài sản cố định

  /** Tài sản cố định */
  'Asset',
  /** Mua sắm TSCĐ */
  'BUTransferFixedAsset',
  /** Chi mua tài sản cố định bằng tiền mặt */
  'CAPaymentFixedAsset',
  /** Chi mua tài sản cố định bằng tiền gửi */
  'BAWitdDrawFixedAsset',
  /** Ghi tăng TSCĐ */
  'VoucherIncrement',
  /** Ghi giảm TSCĐ */
  'VoucherDecrement',
  /** Đánh giá lại TSCĐ */
  'VoucherAdjustment',
  /** Điều chuyển TSCĐ */
  'FATransfer',
  /** Trích khấu hao tài sản cố định */
  'VoucherDepreciate',
  /** Tính hao mòn tài sản cố định */
  'VoucherDepreciation',
  /** Ghi tăng QLTS */
  'FAVoucherIncrement',
  /** Ghi giảm QLTS */
  'FAVoucherDecrement',
  /** Đánh giá lại QLTS */
  'FAVoucherAdjustment',
  /** Trích khấu hao QLTS */
  'FAVoucherDepreciate',
  /** Tính hao mòn QLTS */
  'FAVoucherDepreciation',
  /**Bán TSCĐ */
  'FARevenue',
  /**Mua và ghi tăng */
  'VoucherPurchaseIncrement',
  //#endregion

  //#region Kế toán công cụ dụng cụ

  /** Công cụ dụng cụ */
  'Tools',
  /** Ghi tăng CCDC */
  'SUIncrement',
  /** Điều chuyển công cụ dụng cụ */
  'SUTransfer',
  /** Sổ CCDC */
  'SUBook',
  /** Ghi giảm CCDC */
  'SUDecrement',

  //#endregion

  //#region Kế toán vật tư hàng hóa

  /** Kế toán vật tư hàng hóa */
  'Inventory',
  /** Nhập mua bằng tiền mặt */
  'PUPaymentDetail',
  /** Nhập mua chưa thanh toán */
  'PUInvoiceDetail',
  /** Nhập khác */
  'INInward',
  /** Xuất kho */
  'INOutward',
  /** Điều chỉnh tồn kho */
  'INAjustment',
  /** Chuyển kho */
  'INTransfer',
  /** Tính giá xuất kho */
  'CalcInOutward',
  /** Báo cáo tồn kho */
  'INReport',

  //#endregion

  //#region Kế toán hóa đơn

  /** Hóa đơn điện tử  */
  'Invoice',
  /** Màn hình danh sách Hóa đơn  */
  'InvoiceList',
  /** Lập hóa đơn */
  'CreateInvoice',
  /** Xử lý hóa đơn */
  'InvoiceBot',
  //#endregion

  //#region Hóa đơn điện tử

  /** Hóa đơn điện tử */
  'InvoiceConnect',
  /** Màn hình danh sách Hóa đơn điện tử */
  'SaleInvoice',
  /** Thiết lập kết nối phần mềm Hóa đơn điện tử meInvoice */
  'InvoiceConnect',
  /** Khởi tạo mẫu hóa đơn điện tử (meInvoice) */
  'InvoiceCreate',
  /** Thiết lập chữ ký số */
  'InvoiceSetup',
  /** Thiết lập Email gửi hóa đơn */
  'InvoiceEmail',
  /** Hoàn thiện tờ khai (meInvoice) */
  'InvoiceComplete',
  /** Lập hóa đơn điện tử */
  'SASaleInvoiceDetail',
  /** Phát hành hóa đơn điện tử */
  'InvoiceRelease',
  /** Gửi hóa đơn cho khách hàng */
  'InvoiceSend',
  /** Hủy hóa đơn */
  'InvoiceCancel',
  /** Lập hóa đơn thay thế */
  'InvoiceReplace',
  /** Lập hóa đơn điều chỉnh */
  'InvoiceAdjustment',
  /** Danh sách biên lai */
  'ReceiptList',
  /** Chi tiết detail */
  'ReceiptDetail',
  /**Xem số dư tạm ứng */
  'ViewAdvanceBalance',
  //#endregion

  //#region Kế toán tiền lương

  /** Kế toán tiền lương */
  'Salary',
  /** Tổng hợp ngày nghỉ/làm thêm */
  'StatisticalDayOff',
  /** Tổng hợp thu nhập không thường xuyên */
  'OtherIncome',
  /** Khấu trừ không thường xuyên */
  'PAOtherOutcome',
  /** Truy lĩnh nâng lương */
  'PARetroSalaryIncrease',
  /** Truy lĩnh nâng lương tối thiểu */
  'PARetroStandardSalaryIncrease',
  /** Tính lương, bảo hiểm, thuế thu nhập cá nhân */
  'Salary',
  /** Hạch toán chi phí lương, bảo hiểm, KPCĐ */
  'SalaryKPCD',
  /** Trả lương */
  'PAPaySalaryGenData',
  /** Nộp thuế TNCN */
  'PAPayTax',
  /** Trả lương cho cán bộ nợ lương từ năm trước */
  'SalaryLastYear',
  /** Kết nối với phần mềm Tính lương MISA SalaGov */
  'SalarySalaGov',
  /** Thông báo trả lương đến CBNV */
  'NotifySalaryPayment',
  // Gửi email nhắc nợ
  'ReminderDebtEmail',
  // Thiết lập cấu hình gửi email
  'EmailConfig',

  //#endregion

  //#region Kế toán mua hàng

  /** Kế toán mua hàng */
  'Purchase',
  /** Mua hàng trả tiền ngay */
  'PUPayment',
  /** Mua hàng chưa thanh toán */
  'PUInvoice',
  /** Trả tiền nhà cung cấp */
  'PUVendor',

  //#endregion

  //#region Bán hàng

  /** Bán hàng */
  'Sell',
  /** Bán hàng thu tiền ngay */
  'CAReceiptSale',
  /** Bán hàng chưa thu tiền */
  'SAInvoice',
  /** Thu tiền khách hàng */
  'CAReceiptCustomer',
  /** Hàng bán trả lại */
  'SAReturn',

  //#endregion

  //#region Kế toán thuế

  /** Kế toán thuế */
  'Tax',
  /** Lập bảng kê mua vào */
  'TaxVoucherBuy',
  /** Lập bảng kê bán ra */
  'TaxVoucherSale',
  /** Khấu trừ thuế */
  'TaxVoucherDeduct',
  /** Tờ khai thuế */
  'TaxCreate',
  /** Nộp thuế */
  'TaxSubmit',
  /** Tờ khai thuế TNDN */
  'EnterpriseIncomeTax',

  //#endregion

  //#region Tổng hợp

  /** Tổng hợp */
  'Summary',
  /** Chứng từ nghiệp vụ khác */
  'GLVoucher',
  /** Lập bảng tổng hợp chứng từ cùng loại */
  'VoucherSummaryTable',
  /** Lập chứng từ ghi sổ */
  'GLPostedVoucher',
  /** Sổ cái */
  'SummaryBook',
  /** Tạm tính thuế thu nhập doanh nghiệp */
  'ProvisionalTaxInCome',
  /** Quyết toán thuế thu nhập doanh nghiệp */
  'FinalTaxInComeEnterprise',
  /** Tiền chuyển đến */
  'BATransferDeposit',
  /** Tiền chuyển đi */
  'BATransferWithdraw',
  /** Xác định kết quả hoạt động */
  'GLProfitLossTransfer',
  /** Kết chuyển số dư cuối năm */
  'EndYearTransfer',
  /** Khóa sổ kế toán */
  'NotPostedCloseBook',
  /** Báo cáo tài chính */
  'CRERepList',
  /** Báo cáo quyết toán */
  'CRERepSettleMent',
  /** Nộp báo cáo cho kho bạc */
  'CRERepExportList',
  /** Nộp báo cáo cho cấp trên */
  'CRERepSubmit',
  /** Nộp báo cáo cho cơ quan thuế */
  'CRERepexportListTax',
  /** Quyết toán số dư đầu năm */
  'BeginningYearTransfer',

  //#endregion

  //#region Tiện ích

  /** Nhập số dư ban đầu */
  'OPAccountBalance',
  /** Danh mục */
  'Dictionary',
  /** Thiết lập quy tắc hạch toán đồng thời */
  'AccountParallelRule',
  /** Báo cáo tài chính */
  'ChoseFinanceReportSetting',
  /** Báo cáo tài chính */
  'FinanceReportSetting',
  /** Tùy chọn */
  'CustomSetting',
  /** Sắp xếp lại số chứng từ */
  'SortRefno',
  /** Khóa sổ/Bỏ khóa sổ kỳ kế toán */
  'CloseBook',
  /** Ghi sổ/Bỏ ghi sổ theo lô */
  'LedgerVoucher',
  /** Xuất khẩu báo cáo */
  'ExportReport',
  /** Xuất khẩu dữ liệu */
  'Export',
  /** Nhận mẫu báo cáo */
  'ReportReceive',
  /** Tùy chỉnh mẫu */
  'CustomReport',
  /** Kết xuất dữ liệu – Kết nối KBNN */
  'ExportDVC',
  /** Bảo trì dữ liệu */
  'MainTain',
  /** Sao chép phần mềm */
  'Copy',
  /** Cập nhật thông tin */
  'LiveUpdate',
  /** Máy in */
  'Print',
  /** Thông tin đơn vị */
  'OrganizationInfo',
  /** Quản lý người dùng */
  'User',
  /** Quản lý dữ liệu */
  'Data',
  /** Vai trò quyền hạn */
  'Role',
  /** Tính năng bổ sung */
  'AdditionalFeature',

  /**
   * Báo cáo S05H
   */
  'S05H',

  //#endregion

  //#region video

  'Introduction',
  'IntroductionTT24',

  //#endregion
  /**
   * Xuất khẩu XML
   */
  'CRERepExportXML',

  /**Nhập khẩu excel */
  'ImportExcel',
  /**
   * Tìm kiếm chứng từ
   */
  'SearchVoucher',
  /**
   * Sao lưu phục hồi
   */
  'BackupRestore',
  /**
   * Nhật ký truy cập
   */
  'AccessHistory',
  /*
   * Quản lý người dùng
   */
  'ManageUser',

  /**
   * Nộp báo cáo lên cấp trên
   */
  'CRERepReportSubmit',

  /**
   * Lịch sử gia hạn
   */
  'LicenseHistory',

  /**
   * Hướng dẫn gia hạn
   */
  'License',

  //#region Kết nối phần mềm misa
  /**
   * Kết nối MISA BUMAS
   */
  'Bumas',

  /**
   * Kết nối quản lý tài sản
   */
  'QLTSVN',

  /**
   * Kết nối emis
   */
  'EMIS',

  //#endregion Kết nối phần mềm misa

  /**
   * Hướng dẫn in chứng từ, báo cáo
   */

  'VoucherReport',

  /**
   * Gia hạn sử dụng
   */
  'RenewalLicense',

  // Sao chép dữ liệu
  'CopyData',
  /**
   * Sắp xếp chứng từ nhập, xuất
   */
  'ReArrangeInventory',

  /**
   * Hướng dẫn trên màn hình Preview của các báo cáo, sổ sách, chứng từ còn lại
   */
  'PreviewReportReference',

  /**
   * Hướng dẫn trên Preivew Báo cáo tài chính
   */
  'PreviewReportBCTC',

  /**
   * Hướng dẫn trên Preview Báo cáo quyết toán
   */
  'PreviewReportBCQT',

  /**
   * hướng dẫn sửa mẫu
   */
  'PreviewDesignReport',

  /**
   * hướng dẫn chia sẻ mẫu
   */
  'ShareDesignReport',

  /** Kiểm kê quỹ tiền mặt */
  'CAFundInventory',

  /** Xem hóa đơn tài chính Misa cấp */
  'ViewDebtInvoiceACT',
  /**Chứng từ gốc chưa thanh toán hết */
  'RefNoInvoicePopup',

  // Lập hồ sơ đối chiếu số dư
  'FileDCSD',
  // Thông báo hỗ trợ quyết toán qua zoom
  'HelpSettlementZoomPopup',
  // Thông báo hỗ trợ đối chiếu kho bạc qua zoom
  'HelpTreasuryZoomPopup',
  // kiểm tra số tiền sử dụng vợt quá số dự toán được giao
  'HelpCheckEstimateAmount',
  // Link sang tổng cục thuế
  'GeneralDepartmentTax',
  // link hướng dẫn tra cứu thông tin doanh nghiệp
  'LookUpBusinessInformation',
  // Xem danh sách danh sách ncc có rủi ro
  'ViewListRiskCustomerVendor'
];

export default helps.reduce((obj, x) => ({...obj, [x]: x}), {});
